<template>
<div>
    <v-expand-transition>

    <div v-if="isCompact">
        <v-btn @click="makeCompact(false)">Add Outstandings</v-btn>
    </div>
    </v-expand-transition>
    
    
    <v-expand-transition>
    <div v-if="!isCompact">
        <!-- <v-text-field v-model="text" textarea :rows="7" label="Outstanding Items" hint="Paste all items separated with new line"></v-text-field>                                    -->
        <textarea class="quick-input" v-model="text" rows="7" 
            placeholder="Paste items and separate with new line. Click save..."
        ></textarea>
        <div style="width:100%;text-align:right">
            <a href @click.prevent="demoData">Sample</a> | 
            <a href @click.prevent="quickText('val')">Val</a> |
            <a href @click.prevent="quickText('cos')">COS</a> |
            <a href @click.prevent="quickText('pay')">Payslips</a> |
            <a href @click.prevent="quickText('lmi')">LMI</a>&nbsp;
            <v-btn v-if="items.length" @click="saveItems">Save {{items.length}} Items</v-btn>
            <v-btn v-if="!items.length" @click="makeCompact(true)">Close</v-btn>
        </div>
    </div>
    </v-expand-transition>

</div>
</template>

<script>
export default {
    data() {
        return {
            text: '',
            isCompact: false
        }
    },
    
    props: {
        compact: Boolean
    },

    computed: {
        items() {
            let cleanText = this.text.replace(/\n/g, '|')

            if(this.text.match(/\n\n/))
                cleanText = this.text.replace(/\n\n/g, '|')
        
            cleanText = cleanText.replace('||', '|')
            let items = cleanText.split('|').filter(item => item)
            return items
        }
    },

    methods: {
        makeCompact(value) {
            this.isCompact = value
            this.saveState()
        },

        demoData() {
            this.text = this.$faker().lorem.lines(4)
        },

        quickText(code) {
            if(code == 'val')
                this.text += '\nSubject to valuation.'
            if(code == 'cos')
                this.text += '\nFully signed contract of sale.'
            if(code == 'pay')
                this.text += '\nUpdated most recent payslips.'
            if(code == 'lmi')
                this.text += '\nSubject to lenders mortgage insurance.'
        },

        saveItems() {
            this.$emit('importItems', this.items)
            this.text = ''
            this.isCompact = true
            this.saveState
        },

        saveState() {
            let state = {compact: this.isCompact}
            this.$emit('saveState', state)
        }
    },

    created() {
        this.isCompact = this.compact
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// ImportItems.vue?c8f6d6fe